module.exports = __webpack_public_path__ + "img/wstage.36d39886.png";